module.exports = __webpack_public_path__ + "static/media/range_5_gray.ae37821a.png";